import styles from "./AddToCartButton.module.css";
import React, { useEffect, useState } from "react";
import globalStyles from "../../../styles/globalStyles.module.css";
import { FaCartShopping, FaMinus, FaPlus } from "react-icons/fa6";
import { boosterQuantity, useCartContext } from "../../../context/CartProvider";
import {
  boosterData,
  getMaxPurchasableQuantity,
} from "../../../services/BoosterServices";
import { FaPrint } from "react-icons/fa";
import { usePrintCartProvider } from "../../../context/PrintCartProvider";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../../context/AuthProvider";

export const AddToCartButton: React.FC<{
  booster: boosterData;
  cardsMissing: number;
  numberOfCards: number;
}> = ({ booster, cardsMissing, numberOfCards }) => {
  const { items, addToCart } = useCartContext();
  const [quantity, setQuantity] = useState<number>(1);
  const [maxPurchasable, setMaxPurchasable] = useState<number>(0);
  const printCartProvider = usePrintCartProvider();
  const { user } = useAuth();
  const { t } = useTranslation();

  const handleIncrQuantity = () => {
    if (quantity + 1 > maxPurchasable) return;
    setQuantity(quantity + 1);
  };

  const handleDecrQuantity = () => {
    if (quantity - 1 < 1) return;

    setQuantity(quantity - 1);
  };

  const handleAddToCart = () => {
    if (!booster) return;
    if (items.filter((e) => e.booster.id === booster.id).length > 0) {
      return;
    }
    const item: boosterQuantity = {
      booster: booster,
      quantity: quantity,
      maxQuantity: maxPurchasable,
    };
    //TODO update maxQuantity to /9 when ready
    addToCart(item);
  };

  useEffect(() => {
    const checkBoosterCompleted = async () => {
      const res = await getMaxPurchasableQuantity(booster.id);
      setMaxPurchasable(res);
      if (booster.username === user?.username) {
        setMaxPurchasable(0);
      }
    };
    checkBoosterCompleted();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {Math.ceil(cardsMissing / 9) !== 0 && (
        <div className={styles.quantityButtonsContainer}>
          <button
            className={`${globalStyles.button} ${styles.minus}`}
            onClick={handleDecrQuantity}
          >
            <FaMinus />
          </button>
          <div className={styles.quantityInput}>{quantity}</div>
          <button
            className={`${globalStyles.button} ${styles.plus}`}
            onClick={handleIncrQuantity}
          >
            <FaPlus />
          </button>
        </div>
      )}
      <button
        className={`${globalStyles.button} ${styles.customButton}`}
        onClick={handleAddToCart}
        disabled={maxPurchasable === 0}
      >
        <div>
          <FaCartShopping />
          {maxPurchasable === 0
            ? t("cart.buttons.completed")
            : t("cart.buttons.add")}
        </div>
      </button>
      <button
        className={`${globalStyles.button} ${styles.customButton}`}
        onClick={() =>
          printCartProvider.addToCart({
            booster: booster,
            quantity: 1,
            nbCards: numberOfCards,
          })
        }
        disabled={maxPurchasable !== 0}
      >
        <div>
          <FaPrint />
          {maxPurchasable > 0
            ? t("cart.buttons.unlockPrints", { count: maxPurchasable })
            : t("cart.buttons.print") +
              " " +
              numberOfCards * Number(process.env.REACT_APP_CARD_PRINT_PRICE) +
              " €"}
        </div>
      </button>
    </>
  );
};
